<template>
  <Header
    :HeaderTitle="'Session'"
    :ShowBack="true"
    :ShowLogoutButton="true"
    v-on:back="back"
  ></Header>

  <!-- Content -->
  <main class="content-wrap program-overview-screen">
    <!-- Event -->
    <ProgramItem
      :Program="program"
      :EventId="program.eventId"
      @click="showSwitchProgram = true"
    >
    </ProgramItem>

    <!-- Attendees section -->
    <section class="event-section program-overview-section">
      <!-- Attendees header -->
      <div class="clearfix">
        <div class="float-start event-section__title">Session attendees</div>
        <button @click="viewAttendees" class="float-end event-section__more" type="button">
          View all
          <img
            src="../assets/images/event/icon-view-more.svg"
            alt="View all"
            class="ms-1"
          />
        </button>
      </div>

      <!-- Attendees cards -->
      <div class="row overview-stats">
        <!-- Registered card -->
        <EventStats
          :EventStats="programStats"
          :IsRegistered="true"
          v-on:showRegisteredAttendees="showRegisteredAttendees"
        ></EventStats>

        <!-- Checked-in card -->
        <EventStats
          :EventStats="programStats"
          :IsRegistered="false"
          v-on:showCheckedInAttendees="showCheckedInAttendees"
        ></EventStats>
      </div>

      <div class="program-scan-section">
        <div class="event-section__title">Session scan</div>
        <ScanButton
          :EventId="program.eventId"
          :ProgramId="programId"
          :Scanning="'Session'"
        ></ScanButton>
      </div>
    </section>

    <!-- Switch program popup -->
    <div v-if="showSwitchProgram" class="popup-overlay">
      <div class="popup">
        <div class="popup__header d-flex justify-content-between">
          <div class="">Switch session</div>
          <img
            @click="close"
            src="../assets/images/attendees/icon-close.svg"
            alt="Close"
          />
        </div>

        <div class="popup__body">
          <Program
            :EventId="program.eventId"
            :Programs="this.$store.getters.getPrograms"
            :Event="this.$store.getters.getEvent"
            v-on:closeSwitchProgram="close"
          ></Program>
        </div>

        <div class="popup__footer"></div>
      </div>
    </div>
  </main>
</template>

<script>
import EventStats from "../components/EventStatsComponent.vue";
import ScanButton from "../components/ScanButtonComponent.vue";
import ProgramItem from "../components/ProgramItemComponent.vue";
import Header from "../components/HeaderComponent.vue";
import Program from "../components/ProgramComponent.vue";

export default {
  components: { EventStats, ScanButton, ProgramItem, Header, Program },
  name: "ProgramView",
  data: () => ({
    programStats: Object,
    showSwitchProgram: false,
  }),
  methods: {
    formatDateTime(date) {
      return new Intl.DateTimeFormat("de-DE", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric"
      }).format(new Date(date));
    },
    loadProgramStats() {
      fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/GetProgramStats/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            EventProgramID: this.programId,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            this.programStats = response.data;
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    back() {
      this.$router.back();
    },
    viewAttendees() {
      this.$store.commit("setAttendeeFilter", {
        filter: 0,
      });

      this.$router.push("/programAttendees/");
    },
    showRegisteredAttendees() {
      this.$store.commit("setAttendeeFilter", {
        filter: 2,
      });

      this.$router.push("/programAttendees/");
    },
    showCheckedInAttendees() {
      this.$store.commit("setAttendeeFilter", {
        filter: 3,
      });

      this.$router.push("/programAttendees/");
    },
    close() {
      this.loadProgramStats();
      this.showSwitchProgram = false;
    },
  },
  computed: {
    programId() {
      return this.$store.getters.getEventProgramId;
    },
    program() {
      return this.$store.getters.getProgram;
    },
  },
  beforeMount() {
    this.loadProgramStats();
    this.$store.dispatch("loadCheckInSettings", this.program.eventId).catch(() => {});
  },
};
</script>
